export default __webpack_public_path__ + "static/media/045-squirrel.19cb9ae1.svg";